// extracted by mini-css-extract-plugin
module.exports = {"BackdropPopupContainer":"BackdropPopup_BackdropPopupContainer__qZRXo","BackdropPopup":"BackdropPopup_BackdropPopup__22P9R"};